import Backbone from 'backbone';
import CatalogItem from './CatalogItem';
import app from '../app';

export default Backbone.Collection.extend({
    initialize: function (models, options) {
        this.model = CatalogItem;
    },

    url: function () {
        return `${app.config.contextPath}/catalog_items`;
    },

    get: function (catalogItem) {
        // the "get" implementation of bootstrap only uses the "id" property
        // this causes problems when having multiple data sources
        return this.where({
            id: parseInt(catalogItem.id, 10),
            dataSourceId: catalogItem.get('dataSourceId')
        })[0];
    }
});


// WEBPACK FOOTER //
// ./model/CatalogItems.js